import React, { useState } from 'react'
import { Slider, Popup, Divider } from 'antd-mobile'
import { RPERange } from '../../../utils'
import {
    InformationCircleOutline,
    CloseOutline,
    InformationCircleFill
} from 'antd-mobile-icons'

const RPESelector = ({ rpeValue = 1, onChange, onCommit, trainingLoad = 0 }) => {
    const [infoVisible, setInfoVisible] = useState(false)

    const title = RPERange?.[rpeValue]?.title || 'Unknown'
    const description = RPERange?.[rpeValue]?.description || 'No description available.'

    return (
        <div className="rpe-slider-container">
            <div className="rpe-header">
                <span className="workout-field-value">How did your workout feel?</span>
                <InformationCircleOutline
                    style={{
                        fontSize: '16px',
                        color: '#2E6AD3',
                        textShadow: '0 0 0.5px #2E6AD3, 0 0 0.5px #2E6AD3',
                        marginBottom: '1px'
                    }}
                    onClick={() => setInfoVisible(true)}
                />
            </div>

            <div className="rpe-description">
                <div className="info-inline">
                    <InformationCircleFill className="info-icon" />
                    <span className="info-inline-text">
                        Identify the appropriate rating of perceived exertion that reflects how hard your training session was on average
                    </span>
                </div>
            </div>

            <div className="rpe-description-row">
                <span className="rpe-value">
                    {rpeValue} – {title}
                </span>
                <div>
                    <span className="workout-field-label">Training load (RPEs): </span>
                    <span className="workout-field-value">{trainingLoad}</span>
                </div>
            </div>

            <Slider
                min={1}
                max={10}
                step={1}
                value={rpeValue}
                onChange={onChange}
                onAfterChange={onCommit}
                style={{ '--fill-color': 'red' }}
                trackStyle={{
                    background: 'red',
                    height: '8px',
                    borderRadius: '8px'
                }}
                railStyle={{
                    backgroundColor: 'red',
                    height: '8px',
                    borderRadius: '8px'
                }}
            />

            <div className="slider-dots">
                {Array.from({ length: 10 }, (_, i) => {
                    let offset = (i / 9) * 100
                    if (i === 0) offset += 1.5
                    if (i === 9) offset -= 1.5
                    return (
                        <span
                            key={i}
                            className="slider-dot"
                            style={{ left: `${offset}%` }}
                        />
                    )
                })}
            </div>

            <div className="rpe-labels">
                <span>Nothing at all</span>
                <span>Moderate</span>
                <span>Maximal</span>
            </div>

            <div className="rpe-explanation">
                <div style={{ margin: '14px 0px 10px 0px' }} className="rpe-question">
                    <span>
                        <InformationCircleFill style={{ color: '#ED742E', margin: '0px 6px 0px 0px' }} />
                    </span>
                    What does <strong>{title}</strong> mean?
                </div>
                <div style={{ color: '#666', lineHeight: '1.5' }}>
                    {description}
                </div>
            </div>

            <Popup
                visible={infoVisible}
                onMaskClick={() => setInfoVisible(false)}
                bodyStyle={{
                    height: '30vh',
                    borderTopLeftRadius: 10,
                    borderTopRightRadius: 10
                }}
            >
                <div className="info-container">
                    <div className="info-header">
                        <span className="info-text">What is it?</span>
                        <CloseOutline
                            onClick={() => setInfoVisible(false)}
                            className="close-icon"
                        />
                    </div>
                    <Divider style={{ margin: '6px 0px 16px 0px' }} />
                    <span className="info-description">
                        Perceived exertion refers to how hard you feel your body is working.
                        It provides a fairly good estimate of your actual heart rate, which helps
                        us calculate the training load during physical activity.
                    </span>
                </div>
            </Popup>
        </div>
    )
}

export default RPESelector
